import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  RadioGroup,
  Radio,
  FormControlLabel,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { FocusError } from "focus-formik-error";
import { useFormik } from "formik";
import { React, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { updateLoader } from "../../../_redux/LoaderSlice";
import { updateSnackbar } from "../../../_redux/SnackbarSlice";
import GetJobId from "../../../_utilities/GetJobId";
import { Mode } from "../../../_utilities/constants";
import CkEditor from "../../../components/CkEditor/CkEditor";
import RightSideBar from "../../../components/Rightsidebar/RightSideBar";
import { Encrypt, decrypt } from "../../../_utilities/_encryptDecryptHelper";
import "./mail.css";
import { Link } from "react-router-dom";
import { DashboardPlusicon } from "../../../Icons/DashboardPlusicon";
import {
  sessionExpired,
  getApi,
  postApi,
  putApi,
  deleteApi,
} from "../../../_redux/_apiHelpers/_apihelper";

import { GetUserId, GetUserInfo } from "../../../_utilities/getUserInfo";
const initialSnackbar = { type: "", message: "" };

const Mail = () => {
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);
  const [mode, setMode] = useState(Mode.CREATE);
  const [dataObject, setDataObject] = useState(
    JSON.parse(JSON.stringify(template)),
  );
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [listofTemplate, setListofTemplate] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [noMail, setNoMail] = useState("");

  const dispatch = useDispatch();
  let getJobCode = GetJobId();

  const onReceivePropsHandler = (pannel) => {
    setIsRightSidePannel(pannel);
    setTimeout(() => {
      getEmailTemplates(customerId);
    }, 1000);
  };

  const handleClose = () => {
    setOpen(false);
    setDeleteId(null);
  };

  const handleActionClick = (obj, type) => {
    if (type === "delete") {
      setOpen(true);
      setDeleteId(obj.id);
    } else if (type === "confirmDel" && deleteId !== null) {
      setOpen(false);
      deleteEmailTemplates(deleteId);
    }
  };

  const deleteEmailTemplates = async (deleteId) => {
    try {
      dispatch(updateLoader(true));
      dispatch(updateSnackbar(initialSnackbar));
      const res = await deleteApi(
        `/mgmt/customer/emailtemplates/${deleteId}?atsAdmin=true`,
        {},
        process.env.REACT_APP_USE_MANAGEMENT,
      );
      const jsonData = res.data;
      if (jsonData.code === 200) {
        dispatch(
          updateSnackbar({ type: "success", message: jsonData.message }),
        );
        setTimeout(() => {
          getEmailTemplates(customerId);
        }, 1000);
      }
      dispatch(updateLoader(false));
    } catch (error) {
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
      dispatch(updateLoader(false));
    }
  };

  const layoutPannel = (type) => {
    return {
      title:
        type === Mode.CREATE
          ? "Create Template"
          : type === Mode.EDIT
            ? "Edit Template"
            : "View Template",
      description: "",
      bgImage: `${process.env.PUBLIC_URL}/assests/emal_bg_image.svg`,
    };
  };

  const onHandleComponent = (type, data) => {
    setIsRightSidePannel(true);
    setMode(type);
    setDataObject(
      type === Mode.CREATE ? JSON.parse(JSON.stringify(template)) : data,
    );
  };

  const [getUserId, setGetUserId] = useState(null);

  useEffect(() => {
    async function init() {
      const userIdData = await GetUserId();
      setGetUserId(userIdData);
    }
    init();
  }, []);

  useEffect(() => {
    if (getUserId !== null) {
      setCustomerId(getUserId);
      getEmailTemplates(getUserId);
    }
  }, [getUserId]);

  const getEmailTemplates = async (getUserId) => {
    try {
      dispatch(updateLoader(true));
      dispatch(updateSnackbar(initialSnackbar));

      const res = await getApi(
        `/mgmt/customer/${getUserId}/emailtemplates?atsAdmin=true`,
        process.env.REACT_APP_USE_MANAGEMENT,
      );
      const jsonData = res.data;
      let myData = jsonData.emailtemplates;

      if (jsonData.code === 200) {
        if (myData && myData.length > 0) {
          myData.forEach((list) => {
            list["selectField"] = "";
            list["copyMergeFieldValue"] = "";
            list["candidateResume"] = list?.candidateResume || 0;
          });

          setListofTemplate(myData);
          setNoMail(""); // clear "no mail" state
        } else if (
          Array.isArray(myData) &&
          myData.length === 0 &&
          jsonData.message
        ) {
          setListofTemplate(null);
          setNoMail(jsonData.message);
        } else {
          setListofTemplate(null);
          setNoMail("No templates created.");
        }
      } else {
        setListofTemplate(null);
        setNoMail("Failed to fetch email templates.");
      }
    } catch (error) {
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
      console.error("Error fetching email templates:", error);
      setListofTemplate(null);
      setNoMail("Something went wrong! Please try again.");
      dispatch(
        updateSnackbar({
          type: "error",
          message: "Unable to fetch email templates",
        }),
      );
    } finally {
      dispatch(updateLoader(false));
    }
  };

  return (
    <>
      <div
        className="addvendorsection"
        style={{ display: "flex", height: "34px", gap: "10px", alignItems: 'center' }}
        onClick={(e) => onHandleComponent(Mode.CREATE, null)}
      >
        <DashboardPlusicon width={35} height={36} />
        <h4 className="addnewvendortext">Create E-mail Template</h4>
      </div>
      {listofTemplate && listofTemplate.length > 0 ? (
        <Grid
          container
          style={{ marginBottom: "20px" }}
          spacing={3}
          sx={{ px: 2, overflowX: "auto" }}
        >
          {listofTemplate &&
            listofTemplate.map((list) => (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <div className="thumbnailSection">
                  <ul className="templateActions">
                    <li onClick={(e) => onHandleComponent(Mode.VIEW, list)}>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assests/email_view_icon.svg"
                        }
                        alt=""
                      />
                    </li>
                    <li onClick={(e) => onHandleComponent(Mode.EDIT, list)}>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assests/email_edit_icon.svg"
                        }
                        alt=""
                      />
                    </li>
                    <li onClick={(e) => handleActionClick(list, "delete")}>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assests/email_delete_icon.svg"
                        }
                        alt=""
                      />
                    </li>
                  </ul>
                  <div className="templateThumbnail">
                    <div
                      className="templateContent"
                      dangerouslySetInnerHTML={{ __html: list.emailBody }}
                    ></div>
                  </div>
                </div>
                <h5 className="text-center">{list.name}</h5>
              </Grid>
            ))}
        </Grid>
      ) : (
        noMail && (
          <Box
            sx={{
              border: "1px dashed #e5e5e5",
              padding: 3,
              marginTop: 2,
              textAlign: "center",
              height: "200px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* <div className="nodata-section"> */}
            <img
              src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
              alt="No data"
            />
            <Typography variant="h6" color="textSecondary">
              {noMail}
            </Typography>
            {/* </div> */}
          </Box>
        )
      )}

      {/* ...existing code for sidebar and dialog... */}
      <div className="rightsidebarbtn mailSection">
        {isRightSidePannel ? (
          <RightSideBar
            componentData={
              <ComponentRenderData
                componentType={mode}
                onReceivechildProps={onReceivePropsHandler}
                data={dataObject}
              />
            }
            componentLayout={layoutPannel(mode)}
            onReceiveProps={onReceivePropsHandler}
          />
        ) : (
          ""
        )}
      </div>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog"
        style={{ marginTop: "-26%" }}
      >
        <Box sx={{ width: "395px" }}>
          <DialogTitle className="diabtn">Confirm</DialogTitle>
          <DialogContent>
            <DialogContentText className="diabtnjob" id="alert-dialog">
              <p className="btntext">Are you sure you want to delete ?</p>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="alert-actionbtns">
            <Button onClick={handleClose}>
              <Link href="#" color="#000" underline="always">
                Cancel
              </Link>
            </Button>
            <Button onClick={() => handleActionClick(null, "confirmDel")}>
              Delete
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};

const ComponentRenderData = ({ componentType, onReceivechildProps, data }) => {
  const [getTemplate, setGetTemplate] = useState(data);
  const [fieldsList, setFieldsList] = useState([]);
  const [defaultJobPostings, setDefaultJobPostings] = useState(
    JSON.parse(JSON.stringify(jobpostingsobj)),
  );
  const [defaultApplicants, setDefaultApplicants] = useState(
    JSON.parse(JSON.stringify(applicantsobj)),
  );
  const [defaultClients, setDefaultClients] = useState(
    JSON.parse(JSON.stringify(clientsobj)),
  );
  const [customerId, setCustomerId] = useState(null);
  const [isEmailBody, setIsEmailBody] = useState(false);
  const [emailBodyData, setEmailBodyData] = useState("");
  const [customValues, setCustomValues] = useState(null);
  const [customfieldText, setCustomfieldText] = useState("");

  const dispatch = useDispatch();
  let getJobCode = GetJobId();

  useEffect(() => {
    if (componentType !== Mode.CREATE) {
      formik.values.name = data.name;
      formik.values.subject = data.subject;
      formik.values.to = data.to;
      setEmailBodyData(data.emailBody);
      setIsEmailBody(data.emailBody ? false : true);
      setCustomValues(
        data?.customValues ? JSON.parse(data.customValues) : null,
      );
    }
  }, [componentType]);

  const onChangeHandler = (value, type) => {
    if (type !== "emailBody") {
      let updateTemplate = JSON.parse(JSON.stringify(getTemplate));
      if (type === "category") {
        setFieldsList([]);
        setCustomfieldText("");
        if (value === "Job Openings") {
          setFieldsList(defaultJobPostings);
        } else if (value === "Applicants") {
          setFieldsList(defaultApplicants);
        } else if (value === "Clients") {
          setFieldsList(defaultClients);
        } else if (value === "User") {
          setFieldsList(Userobj);
        }
        updateTemplate.copyMergeFieldValue = "";
        if (value === "Unsubscribe") {
          updateTemplate.copyMergeFieldValue = `@{Unsubscribe}@`;
        }
      } else if (type === "selectField") {
        updateTemplate[type] = value;
        updateTemplate.copyMergeFieldValue = value;
      }
      if (type === "name" || type === "subject" || type === "to") {
        formik.values[type] = value;
      }
      updateTemplate[type] = value;
      setGetTemplate(updateTemplate);
    } else if (type === "emailBody") {
      setIsEmailBody(false);
      setEmailBodyData(value);
    }
  };

  const onCustomChangeHandler = (value) => {
    let customRejex = /^[a-zA-Z0-9_-]*$/;
    if (customRejex.test(value)) {
      let updateTemplate = JSON.parse(JSON.stringify(getTemplate));
      updateTemplate.copyMergeFieldValue = `\@{Custom.${value}}@`;
      updateTemplate.customValues = value;
      setCustomfieldText(value);
      setGetTemplate(updateTemplate);
    } else {
      dispatch(
        updateSnackbar({
          type: "error",
          message:
            "Please enter valid Alpha-numeric character, special character accepted are _ and -",
        }),
      );
    }
  };

  useEffect(() => {
    console.log("update getTemplate", getTemplate);
  }, [getTemplate]);

  useEffect(() => {
    if (data?.category === "Job Openings") {
      setFieldsList(defaultJobPostings);
    } else if (data?.category === "Applicants") {
      setFieldsList(defaultApplicants);
    } else if (data?.category === "Clients") {
      setFieldsList(defaultClients);
    }
  }, [data, defaultJobPostings, defaultApplicants, defaultClients]);

  const [getUserId, setGetUserId] = useState(null);

  useEffect(() => {
    async function init() {
      const userIdData = await GetUserId();
      setGetUserId(userIdData);
    }
    init();
  }, []);

  useEffect(() => {
    if (getUserId !== null) {
      setCustomerId(getUserId);
      fetchData(getUserId);
    }
  }, [getUserId]);

  const fetchData = async (getUserId) => {
    try {
      dispatch(updateLoader(true));
      dispatch(updateSnackbar(initialSnackbar));

      const res = await getApi(
        `/mgmt/customer/${getUserId}/customfields?atsAdmin=true`,
        process.env.REACT_APP_USE_MANAGEMENT,
      );

      const jsonData = res.data;
      const myData = jsonData.customfeilds;

      if (jsonData.code === 200 && Array.isArray(myData) && myData.length > 0) {
        let customfielddata = myData;
        let posingsObj = JSON.parse(JSON.stringify(defaultJobPostings));
        let applicantsObj = JSON.parse(JSON.stringify(defaultApplicants));
        let clientsObj = JSON.parse(JSON.stringify(defaultClients));

        customfielddata.forEach((list, i) => {
          if (parseInt(list.moduleId) === 1 && list.fieldType !== "default") {
            posingsObj.push({
              id: i,
              mappingKey: list.fieldName,
              copyMergeField: `\@{JobOpenings.${list.fieldName}}@`,
              fieldType: "custom",
            });
          } else if (
            parseInt(list.moduleId) === 2 &&
            list.fieldType !== "default"
          ) {
            applicantsObj.push({
              id: i,
              mappingKey: list.fieldName,
              copyMergeField: `\@{Applicants.${list.fieldName}}@`,
              fieldType: "custom",
            });
          } else if (parseInt(list.moduleId) === 3) {
            clientsObj.push({
              id: i,
              mappingKey: list.fieldName,
              copyMergeField: `\@{Clients.${list.fieldName}}@`,
              fieldType: "custom",
            });
          }
        });

        setDefaultJobPostings(posingsObj);
        setDefaultApplicants(applicantsObj);
        setDefaultClients(clientsObj);
      }
      // You can add an else if you want to show a "No custom fields" message
    } catch (error) {
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
      console.error("Error fetching custom fields:", error);
      dispatch(
        updateSnackbar({
          type: "error",
          message: "Unable to fetch custom fields. Please try again.",
        }),
      );
    } finally {
      dispatch(updateLoader(false));
    }
  };

  const onCopyUrlHandler = () => {
    if (getTemplate.copyMergeFieldValue) {
      dispatch(updateSnackbar(initialSnackbar));
      var copyText = document.getElementById("copyMergeFieldValue");
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(copyText.value);
      dispatch(
        updateSnackbar({
          type: "success",
          message: "Merge Field Value Copied!",
        }),
      );
      if (getTemplate.category === "Custom") {
        if (customValues && customValues.length > 0) {
          let isSame = customValues.includes(customfieldText);
          if (!isSame) {
            let newArray1 = [...customValues];
            newArray1.push(customfieldText);
            getTemplate.customValues = JSON.stringify(newArray1);
            setCustomValues(newArray1);
          } else {
            getTemplate.customValues = JSON.stringify(customValues);
          }
        } else {
          let newArray = [];
          newArray.push(customfieldText);
          setCustomValues(newArray);
          getTemplate.customValues = JSON.stringify(newArray);
        }
      } else if (customValues === null) {
        getTemplate.customValues = JSON.stringify([]);
      }
    }
  };

  const handleReset = () => {
    onReceivechildProps(false);
  };

  const handleSubmit = async (event, type) => {
    let modifydata = JSON.parse(JSON.stringify(getTemplate));
    let emailBody = modifydata.emailBody;
    const allPlaceholders = [...emailBody.matchAll(/@\{([^}]+)\}@/g)].map(
      (m) => m[1],
    );
    if (allPlaceholders.length > 0) {
      const customPlaceholders = [
        ...new Set(allPlaceholders.filter((p) => p.startsWith("Custom."))),
      ];
      if (customPlaceholders.length > 0) {
        modifydata.customValues = JSON.stringify(
          customPlaceholders.map((x) => x.split(".")[1]),
        );
      }
    }
    delete modifydata.copyMergeFieldValue;
    delete modifydata.selectField;
    delete modifydata.category;
    // console.log(modifydata);

    if (type !== "Update" || type === "Update") {
      if (type === "Save") {
        modifydata["id"] = Math.random().toFixed(2) * 100;
        saveEmailTemplates(modifydata);
      } else {
        updateEmailTemplates(modifydata);
      }
    }
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Please enter template name"),
    subject: Yup.string().required("Please enter subject name"),
    to: Yup.string().required("Please select To field"),
  });

  const sumbmittedHandler = (e) => {
    if (getTemplate.emailBody === " " || getTemplate.emailBody === "") {
      setIsEmailBody(true);
    }
    formik.handleSubmit();
  };

  const formik = useFormik({
    initialValues: { name: "", subject: "", to: "", custom: "", emailBody: "" },
    validationSchema,
    validate: (values) => {
      let modifydata = JSON.parse(JSON.stringify(getTemplate));
      modifydata["emailBody"] = emailBodyData;
      setGetTemplate(modifydata);
      if (
        modifydata.emailBody &&
        modifydata.emailBody !== " " &&
        modifydata.emailBody !== ""
      ) {
        setIsEmailBody(false);
      }
    },
    onSubmit: async (value) => {
      if (
        value.name !== "" &&
        value.subject !== "" &&
        value.to !== "" &&
        (getTemplate.emailBody === " " || getTemplate.emailBody === "")
      ) {
        setIsEmailBody(true);
      }
      if (
        isEmailBody === false &&
        getTemplate.emailBody !== " " &&
        getTemplate.emailBody !== ""
      ) {
        let type = componentType === Mode.CREATE ? "Save" : "Update";
        handleSubmit(null, type);
      }
    },
  });

  useEffect(() => {
    if (formik.touched.name || formik.touched.subject || formik.touched.to) {
      if (
        getTemplate.emailBody &&
        getTemplate.emailBody !== " " &&
        getTemplate.emailBody !== ""
      ) {
        setIsEmailBody(false);
      } else if (
        getTemplate.emailBody === "" &&
        !formik.touched.name &&
        !formik.touched.subject &&
        !formik.touched.to
      ) {
        setIsEmailBody(false);
      } else if (
        formik.touched.name && formik.touched.subject && formik.touched.to
          ? getTemplate.emailBody === "" &&
          getTemplate.name === "" &&
          getTemplate.subject === "" &&
          getTemplate.to === ""
          : false
      ) {
        setIsEmailBody(true);
      }
    } else if (
      formik.touched.name &&
      formik.touched.subject &&
      formik.touched.to &&
      formik.touched.emailBody === undefined
    ) {
      if (
        formik.touched.name && formik.touched.subject && formik.touched.to
          ? getTemplate.emailBody === "" &&
          getTemplate.name === "" &&
          getTemplate.subject === "" &&
          getTemplate.to === ""
          : false
      ) {
        setIsEmailBody(false);
      }
    }
  }, [getTemplate, formik.touched]);

  const saveEmailTemplates = async (data) => {
    try {
      dispatch(updateLoader(true));
      dispatch(updateSnackbar(initialSnackbar));

      let payload = { ...data, customerId }; // safer than mutating original object

      const res = await postApi(
        `/mgmt/customer/${customerId}/emailtemplates?atsAdmin=true`,
        payload,
        process.env.REACT_APP_USE_MANAGEMENT,
      );

      const jsonData = res.data;

      if (jsonData.code === 200) {
        dispatch(
          updateSnackbar({
            type: "success",
            message: jsonData.message,
          }),
        );
        onReceivechildProps(false);
      } else {
        dispatch(
          updateSnackbar({
            type: "error",
            message: jsonData.message || "Failed to save email template.",
          }),
        );
      }
    } catch (error) {
      console.error("Error saving email templates:", error);
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
      dispatch(
        updateSnackbar({
          type: "error",
          message: "Something went wrong. Please try again.",
        }),
      );
    } finally {
      dispatch(updateLoader(false));
    }
  };

  const updateEmailTemplates = async (data) => {
    try {
      dispatch(updateLoader(true));
      dispatch(updateSnackbar(initialSnackbar));
      let payload = { ...data, customerId }; // safer copy
      const res = await putApi(
        `/mgmt/customer/emailtemplates/${payload.id}?atsAdmin=true`,
        payload,
        process.env.REACT_APP_USE_MANAGEMENT,
      );

      const jsonData = res.data;

      if (jsonData.code === 200) {
        dispatch(
          updateSnackbar({
            type: "success",
            message: jsonData.message,
          }),
        );
        onReceivechildProps(false);
      } else {
        dispatch(
          updateSnackbar({
            type: "error",
            message: jsonData.message || "Failed to update email template.",
          }),
        );
      }
    } catch (error) {
      console.error("Error updating email templates:", error);
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
      dispatch(
        updateSnackbar({
          type: "error",
          message: "Something went wrong. Please try again.",
        }),
      );
    } finally {
      dispatch(updateLoader(false));
    }
  };

  return (
    <>
      <FocusError formik={formik} />
      <Grid container style={{ marginBottom: "20px" }} spacing={3}>
        <Grid item xs={12}>
          <TextField
            className="mailboldlabel"
            id="outlined-basic"
            variant="outlined"
            autoComplete="off"
            label="Template Name &nbsp;"
            style={{ width: "100%" }}
            name="name"
            value={getTemplate.name}
            disabled={componentType === Mode.VIEW ? true : false}
            onChange={(e) => onChangeHandler(e.target.value, "name")}
            onKeyUp={formik.handleBlur}
            InputLabelProps={{ shrink: true }}
            error={formik.errors.name && formik.touched.name ? true : false}
            helperText={
              formik.errors.name && formik.touched.name
                ? formik.errors.name
                : ""
            }
          />
        </Grid>
      </Grid>
      <Grid container style={{ marginBottom: "20px" }} spacing={3}>
        <Grid item xs={12}>
          <FormControl
            fullWidth
            autoComplete="off"
            error={formik.errors.to && formik.touched.to ? true : false}
          >
            <InputLabel
              id="category-select-label"
              shrink={true}
              className="mailboldSelectlabel"
            >
              To{" "}
            </InputLabel>
            <Select
              value={getTemplate.to}
              name="to"
              labelId="to"
              id="to"
              disabled={componentType === Mode.VIEW ? true : false}
              label="To&nbsp;"
              autoComplete="off"
              onChange={(e) => onChangeHandler(e.target.value, "to")}
              style={{
                height: "3.5rem",
                borderRadius: "4px",
                width: "100%",
                textAlign: "left",
              }}
              onBlur={formik.handleBlur}
            >
              {toOptions.map((list) => (
                <MenuItem
                  className="selectOptions"
                  key={list.id}
                  value={list.name}
                >
                  {" "}
                  {list.title}{" "}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>
              {formik.errors.to && formik.touched.to ? formik.errors.to : ""}
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container style={{ marginBottom: "25px" }}>
        <TextField
          className="boldlabel"
          id="outlined-basic"
          variant="outlined"
          autoComplete="off"
          label="Subject &nbsp;"
          style={{ width: "100%" }}
          name="subject"
          value={getTemplate.subject}
          disabled={componentType === Mode.VIEW ? true : false}
          onKeyUp={formik.handleBlur}
          InputLabelProps={{ shrink: true }}
          onChange={(e) => onChangeHandler(e.target.value, "subject")}
          error={formik.errors.subject && formik.touched.subject ? true : false}
          helperText={
            formik.errors.subject && formik.touched.subject
              ? formik.errors.subject
              : ""
          }
        />
      </Grid>
      <Grid container style={{ marginBottom: "20px" }} spacing={3}>
        <Grid item xs={4}>
          <div className="">
            <FormControl fullWidth autoComplete="off">
              <InputLabel
                id="category-select-label"
                shrink={true}
                className="mailboldSelectlabel"
              >
                Select Module
              </InputLabel>
              <Select
                value={getTemplate.category}
                name="jobStatus"
                labelId="category-select-label"
                id="category-select"
                disabled={componentType === Mode.VIEW ? true : false}
                label="Use Category*&nbsp;&nbsp;"
                autoComplete="off"
                onChange={(e) => onChangeHandler(e.target.value, "category")}
                style={{
                  height: "3.5rem",
                  borderRadius: "4px",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                {[
                  ...categoryList,
                  getTemplate.to === "applicants" ? { id: 6, name: "Unsubscribe" } : null
                ]
                  .filter(Boolean)
                  .map((list) => (
                    <MenuItem
                      className="selectOptions"
                      key={list.id}
                      value={list.name}
                    >
                      {list.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </div>
        </Grid>
        <Grid item xs={4}>
          {getTemplate.category === "Custom" ? (
            <TextField
              id="outlined-basic"
              label="Custom"
              variant="outlined"
              className="boldlabel"
              onChange={(e) => onCustomChangeHandler(e.target.value)}
              disabled={componentType === Mode.VIEW ? true : false}
              InputLabelProps={{ shrink: true }}
              value={customfieldText}
              onKeyPress={(e) => {
                var str = e.target.value;
                str = str.replace(/\s/g, "");
                let updateTemplate = JSON.parse(JSON.stringify(getTemplate));
                updateTemplate.copyMergeFieldValue = `\@{Custom.${str}}@`;
                updateTemplate.customValues = str;
                setCustomfieldText(str);
                setGetTemplate(updateTemplate);
                if (e.which === 32) {
                  dispatch(
                    updateSnackbar({
                      type: "error",
                      message: "Spaces are not allowed",
                    }),
                  );
                }
              }}
              style={{
                height: "3.5rem",
                borderRadius: "4px",
                width: "100%",
                textAlign: "left",
              }}
            />
          ) : (
            <div className="">
              <FormControl fullWidth autoComplete="off">
                <InputLabel
                  id="category-select-label"
                  shrink={true}
                  className="mailboldSelectlabel"
                >
                  Select Field
                </InputLabel>
                <Select
                  value={getTemplate.selectField}
                  name="selectField"
                  labelId="category-select-label"
                  id="category-select"
                  disabled={componentType === Mode.VIEW || getTemplate.category === 'Unsubscribe' ? true : false}
                  label="Select Field*&nbsp;"
                  autoComplete="off"
                  onChange={(e) =>
                    onChangeHandler(e.target.value, "selectField")
                  }
                  style={{
                    width: "100%",
                    height: "3.5rem",
                    borderRadius: "4px",
                    textAlign: "left",
                  }}
                >
                  {fieldsList.length > 0 &&
                    fieldsList.map((list) => (
                      <MenuItem
                        className="selectOptions"
                        key={list.id}
                        value={list.copyMergeField}
                      >
                        {list.mappingKey}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>
          )}
        </Grid>
        <Grid item xs={4}>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <TextField
              className="boldlabel"
              id="copyMergeFieldValue"
              variant="outlined"
              autoComplete="off"
              label="Copy Merge Field Value &nbsp;&nbsp;&nbsp;&nbsp;"
              style={{ width: "90%" }}
              name="copyMergeFieldValue"
              value={getTemplate.copyMergeFieldValue}
              disabled={true}
            />
            <ContentCopyIcon
              style={{
                paddingLeft: "10px",
                paddingTop: "13px",
                cursor: "pointer",
                color: "#838789",
              }}
              onClick={onCopyUrlHandler}
            />
          </div>
        </Grid>
      </Grid>
      <FormControl fullWidth error={isEmailBody === true ? true : false}>
        <div
          id="emailBody"
          className={isEmailBody === true ? "brd-danger" : ""}
        >
          <CkEditor
            data={emailBodyData && emailBodyData === "" ? " " : emailBodyData}
            error={
              formik.errors.emailBody && formik.touched.emailBody ? true : false
            }
            name="emailBody"
            autoComplete="off"
            isReadonly={componentType === Mode.VIEW ? true : false}
            onUpdatehandler={(update) =>
              onChangeHandler(update.data, "emailBody")
            }
            onBlur={formik.handleBlur}
            enableCustomButton={getTemplate.to === "clients" ? true : false}
          />
          {/* {isEmailBody === true ? ( */}
          {isEmailBody === true ? (
            <FormHelperText className="text-danger">
              Please enter E-mail body
            </FormHelperText>
          ) : null}
        </div>
        {getTemplate.to === "clients" && (
          <div style={{ margin: "10px 10px 0px 0px", width: "fit-content" }}>
            <FormControl>
              <RadioGroup
                row
                id="mailRadioGroup"
                name="candidateResume"
                value={getTemplate.candidateResume}
                onChange={(e) => {
                  setGetTemplate((prev) => ({
                    ...prev,
                    candidateResume: e.target.value,
                  }));
                }}
              >
                <strong style={{ margin: "20px 20px 20px 0px " }}>
                  Include Candidate Resume
                </strong>
                <FormControlLabel
                  value={1}
                  control={<Radio />}
                  label="YES"
                  disabled={componentType === Mode.VIEW ? true : false}
                />
                <FormControlLabel
                  value={0}
                  control={<Radio />}
                  label="NO"
                  disabled={componentType === Mode.VIEW ? true : false}
                />
              </RadioGroup>
            </FormControl>
          </div>
        )}
      </FormControl>
      {componentType !== Mode.VIEW ? (
        <div className="cancelsavebutton">
          <Stack spacing={2} direction="row">
            <Button
              className="mailcancelbtn"
              size="small"
              variant="text"
              sx={{ color: "#FF0000", textTransform: "capitalize" }}
              type="reset"
              onClick={handleReset}
            >
              <Link sx={{ color: "red" }} underline="always">
                Cancel
              </Link>
            </Button>
            <Button
              className="emailsavebtn"
              size="small"
              variant="contained"
              type="submit"
              onClick={(e) => {
                sumbmittedHandler(e);
              }}
            >
              {componentType === Mode.CREATE ? "Save" : "Update"}
            </Button>
          </Stack>
        </div>
      ) : null}
    </>
  );
};
export default memo(Mail);

const categoryList = [
  { id: 1, name: "Job Openings" },
  { id: 2, name: "Applicants" },
  { id: 3, name: "Clients" },
  { id: 4, name: "Custom" },
  { id: 5, name: "User" },
];

const template = {
  name: "",
  category: "",
  to: "",
  subject: "",
  selectField: "",
  copyMergeFieldValue: " ",
  emailBody: "",
  customValues: "[]",
  candidateResume: 0,
};

const jobpostingsobj = [
  {
    id: 1,
    mappingKey: "Job Code",
    copyMergeField: "@{JobOpenings.jobCode}@",
    fieldType: "default",
  },
  {
    id: 2,
    mappingKey: "Job Title",
    copyMergeField: "@{JobOpenings.jobTitle}@",
    fieldType: "default",
  },
  {
    id: 3,
    mappingKey: "Job Status",
    copyMergeField: "@{JobOpenings.jobStatus}@",
    fieldType: "default",
  },
  {
    id: 4,
    mappingKey: "Job Type",
    copyMergeField: "@{JobOpenings.jobType}@",
    fieldType: "default",
  },
  {
    id: 5,
    mappingKey: "Location",
    copyMergeField: "@{JobOpenings.location}@",
    fieldType: "default",
  },
  {
    id: 6,
    mappingKey: "Pay rate/Salary",
    copyMergeField: "@{JobOpenings.payBillRate}@",
    fieldType: "default",
  },
  {
    id: 7,
    mappingKey: "Primary Skills",
    copyMergeField: "@{JobOpenings.primarySkills}@",
    fieldType: "default",
  },
  {
    id: 8,
    mappingKey: "Work Model",
    copyMergeField: "@{JobOpenings.workModel}@",
    fieldType: "default",
  },
  {
    id: 9,
    mappingKey: "Job Description For Social Media",
    copyMergeField: "@{JobOpenings.jobDescForSM}@",
    fieldType: "default",
  },
  {
    id: 10,
    mappingKey: "Job Description",
    copyMergeField: "@{JobOpenings.jobDesc}@",
    fieldType: "default",
  },
  {
    id: 11,
    mappingKey: "Secondary Skills",
    copyMergeField: "@{JobOpenings.secondarySkills}@",
    fieldType: "default",
  },
  {
    id: 12,
    mappingKey: "Priority",
    copyMergeField: "@{JobOpenings.priority}@",
    fieldType: "default",
  },
];

const applicantsobj = [
  {
    id: 1,
    mappingKey: "Applicant Code",
    copyMergeField: "@{Applicants.applicantCode}@",
    fieldType: "default",
  },
  {
    id: 2,
    mappingKey: "Contact Number",
    copyMergeField: "@{Applicants.contactNumber}@",
    fieldType: "default",
  },
  {
    id: 3,
    mappingKey: "E-mail Address",
    copyMergeField: "@{Applicants.emailId}@",
    fieldType: "default",
  },
  {
    id: 4,
    mappingKey: "FullName",
    copyMergeField: "@{Applicants.fullName}@",
    fieldType: "default",
  },
  {
    id: 5,
    mappingKey: "Total Experience",
    copyMergeField: "@{Applicants.totalExperience}@",
    fieldType: "default",
  },
  {
    id: 6,
    mappingKey: "Location",
    copyMergeField: "@{Applicants.location}@",
    fieldType: "default",
  },
];

const clientsobj = [
  {
    id: 1,
    mappingKey: "Client's Name",
    copyMergeField: "@{Clients.clientName}@",
    fieldType: "default",
  },
  {
    id: 2,
    mappingKey: "End Client Name",
    copyMergeField: "@{Clients.endClientName}@",
    fieldType: "default",
  },
  {
    id: 3,
    mappingKey: "Region",
    copyMergeField: "@{Clients.region}@",
    fieldType: "default",
  },
  {
    id: 4,
    mappingKey: "Status",
    copyMergeField: "@{Clients.status}@",
    fieldType: "default",
  },
  {
    id: 5,
    mappingKey: "Manager's E-mail ID",
    copyMergeField: "@{Clients.managerEmail}@",
    fieldType: "default",
  },
  {
    id: 6,
    mappingKey: "Hiring Manager's Name",
    copyMergeField: "@{Clients.hiringManagerName}@",
    fieldType: "default",
  },
  {
    id: 7,
    mappingKey: "Hiring Manager's E-mail ID",
    copyMergeField: "@{Clients.hiringManagerEmailId}@",
    fieldType: "default",
  },
];

const Userobj = [
  {
    id: 1,
    mappingKey: "First Name",
    copyMergeField: "@{User.firstName}@",
    fieldType: "default",
  },
  {
    id: 2,
    mappingKey: "Last Name",
    copyMergeField: "@{User.lastName}@",
    fieldType: "default",
  },
  {
    id: 3,
    mappingKey: "E-mail Address",
    copyMergeField: "@{User.emailId}@",
    fieldType: "default",
  },
  {
    id: 4,
    mappingKey: "Alias Name",
    copyMergeField: "@{User.aliasName}@",
    fieldType: "default",
  },
  {
    id: 5,
    mappingKey: "Phone number",
    copyMergeField: "@{User.phoneNumber}@",
    fieldType: "default",
  },
];

const DynamicLinksobj = [
  {
    id: 1,
    mappingKey: "Unsubscribe",
    copyMergeField: "@{DynamicLinks.unsubscribe}@",
    fieldType: "default",
  },
  {
    id: 2,
    mappingKey: "LinkedIn",
    copyMergeField: "@{DynamicLinks.linkedin}@",
    fieldType: "default",
  },
  {
    id: 3,
    mappingKey: "Facebook",
    copyMergeField: "@{DynamicLinks.facebook}@",
    fieldType: "default",
  },
  {
    id: 4,
    mappingKey: "Twitter",
    copyMergeField: "@{DynamicLinks.twitter}@",
    fieldType: "default",
  },
  {
    id: 5,
    mappingKey: "Instagram",
    copyMergeField: "@{DynamicLinks.instagram}@",
    fieldType: "default",
  },
];

const toOptions = [
  { id: 1, title: "Applicants", name: "applicants" },
  { id: 2, title: "Clients", name: "clients" },
];
